import { useQueryClient } from '@tanstack/react-query';

import { useQuery } from '@hooks/reactQuery';

import { getAssetOwnersForFilter } from '@api/organisations';

import { IOrganisationEntity } from '@interfaces/organisation/organisations';

import { ASSET_OWNERS_FOR_FILTER } from '@constants/queryKeys';

interface IUseQueryAssetOwnersForFilterReturn {
	assetOwnersForFilter: IOrganisationEntity[];
	prefetchAssetOwnersForFilter: () => Promise<void>;
}

export const useQueryAssetOwnersForFilter = (): IUseQueryAssetOwnersForFilterReturn => {
	const queryClient = useQueryClient();

	const { data } = useQuery<Array<IOrganisationEntity>>({
		queryKey: [ASSET_OWNERS_FOR_FILTER],
		queryFn: getAssetOwnersForFilter,
		select: (items) => {
			return items.sort((a, b) => a?.name?.localeCompare(b?.name));
		},
		refetchOnWindowFocus: false,
	});

	const prefetchAssetOwnersForFilter = async () => {
		return await queryClient.prefetchQuery({
			queryKey: [ASSET_OWNERS_FOR_FILTER],
			queryFn: getAssetOwnersForFilter,
		});
	};

	return {
		assetOwnersForFilter: data || [],
		prefetchAssetOwnersForFilter,
	};
};
